"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidEstimateResponseToJSON = exports.BidEstimateResponseFromJSONTyped = exports.BidEstimateResponseFromJSON = exports.instanceOfBidEstimateResponse = void 0;
var runtime_1 = require("../runtime");
var CostModel_1 = require("./CostModel");
/**
 * Check if a given object implements the BidEstimateResponse interface.
 */
function instanceOfBidEstimateResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBidEstimateResponse = instanceOfBidEstimateResponse;
function BidEstimateResponseFromJSON(json) {
    return BidEstimateResponseFromJSONTyped(json, false);
}
exports.BidEstimateResponseFromJSON = BidEstimateResponseFromJSON;
function BidEstimateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bidEstimateMin': !(0, runtime_1.exists)(json, 'bid_estimate_min') ? undefined : json['bid_estimate_min'],
        'bidEstimateMax': !(0, runtime_1.exists)(json, 'bid_estimate_max') ? undefined : json['bid_estimate_max'],
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel_1.CostModelFromJSON)(json['cost_model']),
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.BidEstimateResponseFromJSONTyped = BidEstimateResponseFromJSONTyped;
function BidEstimateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bid_estimate_min': value.bidEstimateMin,
        'bid_estimate_max': value.bidEstimateMax,
        'cost_model': (0, CostModel_1.CostModelToJSON)(value.costModel),
        'currency': value.currency,
    };
}
exports.BidEstimateResponseToJSON = BidEstimateResponseToJSON;
